// extracted by mini-css-extract-plugin
export default {"framework-selector":"P_b8 d-flex","framework-selector__icon":"P_b9","framework-selector__option":"P_cb p-2 flex-grow-1 ml-2","framework-selector__option--selected":"P_cc"};